export default "__VITE_ASSET__CPxtWY9Z__"